module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.flight.name))]), _vm._v(" "), _c('md-switch', {
    model: {
      value: (_vm.showDiagram),
      callback: function($$v) {
        _vm.showDiagram = $$v
      },
      expression: "showDiagram"
    }
  }, [_c('div', {
    staticClass: "sub-header"
  }, [_vm._v(_vm._s(((_vm.flightMatches.length) + " matches")))])]), _vm._v(" "), _c('p'), _vm._v(" "), (_vm.showDiagram) ? _c('table', {
    staticClass: "flight"
  }, _vm._l((_vm.rowOfMatches), function(row) {
    return _c('tr', _vm._l((row), function(match) {
      return _c('td', {
        key: match.id,
        class: match === _vm.MATCH_EMPTY ? 'empty' : match === _vm.MATCH_CONNECTOR ? 'match-connector' : 'match'
      }, [(match.id) ? _c('Match', {
        attrs: {
          "match": match,
          "tournament": _vm.tournament
        }
      }) : _vm._e()], 1)
    }))
  })) : _vm._e(), _vm._v(" "), (_vm.flight.rounds.length < 2 && _vm.flight.standings && _vm.flight.standings.length > 0) ? _c('div', [_c('p'), _vm._v(" "), _c('md-table', {
    attrs: {
      "md-card": ""
    },
    model: {
      value: (_vm.flight.standings),
      callback: function($$v) {
        _vm.$set(_vm.flight, "standings", $$v)
      },
      expression: "flight.standings"
    }
  }, [_c('md-table-toolbar', [_c('h3', [_vm._v(_vm._s(_vm.flight.name) + " Standings")])]), _vm._v(" "), _c('md-table-head', {
    attrs: {
      "md-numeric": ""
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('md-table-head', [_vm._v("Name")]), _vm._v(" "), _c('md-table-head', [_vm._v("Results")]), _vm._v(" "), _c('md-table-head', {
    attrs: {
      "md-numeric": ""
    }
  }, [_vm._v("Points")]), _vm._v(" "), _vm._l((_vm.flight.standings), function(item, index) {
    return _c('md-table-row', {
      key: item.id
    }, [_c('md-table-cell', {
      attrs: {
        "md-numeric": ""
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.resultSequence && item.resultSequence.join("·")))]), _vm._v(" "), _c('md-table-cell', {
      attrs: {
        "md-numeric": ""
      }
    }, [_vm._v(_vm._s(item.points))])], 1)
  })], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4ced90a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tournamentComponents/flightDiagram.vue
// module id = 464
// module chunks = 1